import { Button } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConfirmModal } from '../../../shared';
import { useMergeSupportCase } from '../../hooks';

interface Props {
    subjectId: string;
    targetId: string;
    onClose?: () => void;
}

export const MergeSupportCases: FC<Props> = ({ subjectId, targetId, onClose }) => {
    const { t } = useTranslation();
    const { mutateAsync: merge } = useMergeSupportCase();
    const location = useLocation();
    const navigate = useNavigate();

    const onMerge = async () => {
        await merge({ subjectId: subjectId, targetId: targetId });

        if (onClose) onClose();

        if (location.pathname === '/registration/info') {
            navigate(`/registration/info?case=${targetId}`);
        } else {
            const currentPage = location.pathname.split('/').pop();
            navigate(`/support/support-cases/${targetId}/${currentPage}`);
        }
    };

    return (
        <ConfirmModal
            button={
                <Button variant="outlined" sx={{ width: '100%', mx: 0.5 }} size="small">
                    {t('mergeAndKeepInfo')}
                </Button>
            }
            title={t('merge')}
            text={t('mergeConfirmation')}
            onConfirm={onMerge}
        />
    );
};
